<script setup lang="ts">
import background from '~/assets/images/backgrounds/main.jpg';

const { t } = useI18n();

const scroll = () => {
  document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
};
</script>

<template>
  <section class="section-welcome section-bottom-shadow relative">
    <NuxtImg
      :src="background"
      width="1800"
      height="1201"
      sizes="lg:100vw xl:100vw xxl:100vw"
      format="avif"
      :alt="t('subtitle')"
      class="page-image-preview"
      preload
    />
    <div class="section-welcome__content p-section z-1">
      <BasePulsedLogo
        class="section-welcome__logo mx-auto mt-6 sm:mt-8 md:mt-12 mb-3 md:mb-4"
      />

      <div class="lg:container flex flex-col items-center">
        <h1 class="section-welcome__title mt-0 uppercase">
          {{ t('title') }}
        </h1>
        <h2 class="section-welcome__description">
          {{ t('subtitle') }}
        </h2>
        <div class="section-welcome__links">
          <Button
            @click="scroll"
            :label="t('more')"
            rounded
            size="large"
            class="!px-8 sm:!px-12 sm:!py-4 text-xl"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<i18n>
en:
  title: Erotic games for couple
  subtitle: Unforgettable sex with your soulmate
  more: Find out more

ru:
  title: Эротические игры для двоих
  subtitle: Незабываемый секс со своей второй половинкой
  more: Узнать больше

de:
  title: Erotische Spiele für zwei
  subtitle: Unvergesslicher Sex mit deinem Seelenverwandten
  more: Erfahren Sie mehr

es:
  title: Juegos eróticos para dos
  subtitle: Sexo inolvidable con tu alma gemela
  more: Descubra más

fr:
  title: Jeux érotiques à deux
  subtitle: Sexe inoubliable avec votre âme sœur
  more: En savoir plus
</i18n>

<style lang="scss">
.section-welcome {
  min-height: 92vh;
  color: white;
  background-color: rgb(16, 16, 20);
  position: relative;
  display: flex;
  flex-direction: column;

  &__content {
    flex: 1;
    padding: var(--header-height) 24px 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    position: relative;
    background-color: rgba(14, 1, 29, 0.7);
  }

  &__logo {
    opacity: 0;
    animation: show 0.5s 0.2s ease forwards;
  }

  &__title {
    text-align: center;
    font-size: 28px;
    animation: show 0.5s 0.7s ease forwards;
    opacity: 0;
    margin-bottom: 2rem;
    @media (min-width: 640px) {
      font-size: 36px;
    }
    @media (min-width: 1024px) {
      font-size: 56px;
    }
    @media (min-width: 1366px) {
      font-size: 62px;
    }
    @media (min-width: 1920px) {
      font-size: 84px;
    }
  }
  &__description {
    text-align: center;
    font-size: 16px;
    margin-top: 0;
    animation: show 0.5s 1.2s ease forwards;
    opacity: 0;
    @media (min-width: 640px) {
      font-size: 18px;
      white-space: pre-line;
    }
    @media (min-width: 1024px) {
      font-size: 24px;
    }
    @media (min-width: 1366px) {
      font-size: 28px;
    }
    @media (min-width: 1920px) {
      font-size: 32px;
    }
  }
  &__links {
    display: flex;
    gap: 16px;
    margin-top: 32px;
    margin-bottom: 32px;
    flex-direction: column;
    align-items: center;
    animation: show 0.5s 1.7s ease forwards;
    opacity: 0;
    @media (min-width: 440px) {
      gap: 32px;
      flex-direction: row;
    }
    @media (min-width: 1600px) {
      margin-top: 54px;
    }
    a {
      text-decoration: none;
    }
  }
  @keyframes show {
    0% {
      transform: translateY(40px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
